import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import Form from "react-bootstrap/Form";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { RegistrationAddressValidationSchema } from "../utils/Validations";
import GetAddressInfo from "../hooks/GetAddressInfo";
import { radiusCover } from "../utils/commanFiles";

export default function RegistrationAddress() {
  const deviceType = localStorage.getItem("deviceType") || "";
  const fcm_token = localStorage.getItem("fcm_token") || "";
  const Navigate = useNavigate();
  const { addressData, getAddress } = GetAddressInfo();  // Ensure this function works correctly and fetches the data

  const initialdata = {
    postCode: "",
    latitude: addressData?.latitude || 0,
    longitude: addressData?.longitude || 0,
    address: "",
    radiusCover: "",
    role:"Vendor",
    deviceType: deviceType,
    deviceToken: fcm_token,
  };

  const userId = localStorage.getItem("userId");

  const { data: userDetails, error: userError, isLoading: userLoading } = useQuery({
    queryKey: ["userDetails", userId],
    queryFn: () => getRequest(`profile/info?id=${userId}`),
    enabled: !!userId,
  });

  const editOptions = userDetails?.data ? userDetails.data : initialdata;

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      const modifyData = {
        postCode: data?.postCode || "",
        address: data?.address || "",
        latitude: addressData?.latitude || 0,
        longitude: addressData?.longitude || 0,
        radiusCover: Number(data?.radiusCover) || "",
        id: userId,
        role:"Vendor" ,
        deviceType: deviceType,
        deviceToken: fcm_token,
      }
      return postRequest(`/auth/register`, modifyData);
    },
    onSuccess: (data) => {
      if (!userId) {
        localStorage.setItem("userId", data?.data?.id);
      }
      Navigate("/registration-business");
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  // Handle the click of the button to trigger getAddress and set the state
  const handleSearchClick = (postCode) => {
    if (postCode) {
      getAddress(postCode);  // This should update the addressData state with the new addresses
    }
  }

  useEffect(() => {
    if (editOptions?.postCode) {
      getAddress(editOptions?.postCode);  // Trigger the getAddress function with the initial postCode
    }
  }, [editOptions?.postCode]); // Only re-run when postCode changes

  return (
    <Layout>
      <Container>
        <Row>
          <Col lg={6}>
            <div className="pre-registration">
              <div className="pre-registration-box">
                <h3 className="RegisTitle">Your Service Area</h3>
                <p>
                  Tell us where you offer your services. If you offer multiple
                  addresses, put your main one here.
                </p>
                <div className="pre-registration-form">
                  <div className="h-100 m-0">
                    <h3  className="RegisTitle">Location</h3>
                    <p>
                      Provide the following information and we’ll arrange the
                      next steps.
                    </p>

                    <Formik
                      initialValues={editOptions}
                      validationSchema={RegistrationAddressValidationSchema}
                      enableReinitialize={true}
                      onSubmit={(values) => {
                        mutate(values);
                      }}
                    >
                      {({ handleSubmit, values, setFieldValue }) => (
                        <Form className="cmn-form-set" onSubmit={handleSubmit}>
                          <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Post code</Form.Label>
                            <div className="input-w-button">
                              <Field
                                type="text"
                                name="postCode"
                                className="form-control"
                                placeholder="Type here"
                                value={values.postCode}
                                onChange={(e) => {
                                  const upperCaseValue = e.target.value.toUpperCase();
                                  setFieldValue("postCode", upperCaseValue);
                                }}
                              />
                              <Button
                                variant="primary"
                                className="modal-f-btn pop-cancel-btn"
                                onClick={() => handleSearchClick(values.postCode)}  // Call the handleSearchClick function here
                              >
                                Search
                              </Button>
                            </div>
                            <ErrorMessage
                              name="postCode"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>

                          <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Confirm Your Address</Form.Label>
                            <Field as="select" name="address" className="form-control" value={values.address}>
                              <option value="">Select Address</option>
                              {addressData?.addresses?.map((item, index) => {
                                return (
                                  <option
                                    value={item?.formatted_address
                                      ?.filter(item => item.trim() !== '')
                                      .map(item => item.split(',').map(word => word.trim()).join(','))
                                    }
                                    key={index}
                                  >
                                    {item?.formatted_address
                                      ?.filter((item) => item !== "")
                                      .join(", ")}
                                  </option>
                                );
                              })}
                            </Field>
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>

                          <Form.Group className="mb-3" controlId="formradiusCover">
                            <Form.Label>Radius Covered (Miles)</Form.Label>
                            <Field
                              id="category"
                              as={Form.Select}
                              name="radiusCover"
                              aria-label="Default select example"
                            >
                              <option value="">Select Radius</option>
                              {radiusCover.map((item, i) => (
                                <option key={i} value={item.value}>{item.label}</option>
                              ))}
                            </Field>
                            <ErrorMessage
                              name="radiusCover"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>

                          <div className="registration-form-action">
                            <button
                              type="button"
                              className="theme-btn"
                              onClick={() => Navigate("/pre-registration")}
                            >
                              Back
                            </button>
                            <button type="submit" className="white-btn">
                              Next
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
